module.exports = "<div>\n  <app-base></app-base>\n</div>\n<app-simple-table [dataService]=\"dataService\"></app-simple-table>"